import styled, { css } from "styled-components";
import { THEME_COLORS } from "../../styles/theme";
import { FontSize16, FontFamilyRegular } from "../fonts";

export const ButtonBaseStyle = css`
    position: relative;
    width: 100%;
    line-height: 42px;
    height: 42px;
    ${FontFamilyRegular};
    ${FontSize16};
    color: ${props => props.theme.color[props.color] || props.theme.color.white};
    border-radius: 30px;
    border: none;
    background: none;
    text-align: center;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    box-shadow: ${props => props.hasOnlyOutline ? 'none' : `0px 0px 20px 2px ${props.theme.color.shadowRed}`};
    outline: none;
    will-change: box-shadow;
    transition: all 0.2s ease-in 0s;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 1280px) {
        &:hover {
            @media (min-width: 768px) {
                box-shadow: 0px 0px 20px 8px ${props =>
                props.theme.color.shadowRed};            
            }
            
            &:after {
                background-color: ${props => props.theme.color.whiteHover};
                opacity: 1;
            }
        }
    }

    &:active {
        &:after {
            background-color: ${props => props.theme.color.blackPressed};
            opacity: 1;
        }
    }

    ${props =>
        props.short &&
        css`
            line-height: 42px;
            border-radius: 21px;

            @media (min-width: 1440px) {
                line-height: 40px;
                border-radius: 30px;
            }
        `
    }

    ${props =>
        props.tall &&
        css`
            line-height: 80px;
            border-radius: 40px;
        `
    }

    ${props =>
        props.mainColor &&
        css`
            background: ${props => props.theme.color[props.mainColor]};
        `
    }

    ${props => props.hasOnlyOutline &&
        css`
            background: ${props => props.theme.color[THEME_COLORS.white]}
        `
    }

    ${props =>
        props.isDisabled &&
        css`
            background: ${props => props.theme.color.gray};
            pointer-events: none;
        `
    }

    ${props =>
        props.icon &&
        css`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            flex-direction: ${props.invertIcon ? "row-reverse" : "row"};
        `
    }

    ${props =>
        props.solo &&
        css`
            min-width: 300px;
            max-width: 300px;
            position: relative;
            display: block;
            margin: 40px auto !important;
            margin-top: 40px;
            margin-bottom: 40px;
        `
    }

    &:after {
        content: '';
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        will-change: opacity;
        border-radius: 30px;
        transition: all 0.2s ease-in 0s;
    }

    ${props => props.hasOnlyOutline && css`
        &:before {
            position: absolute;
            top: -1px; bottom: -1px;
            left: -1px; right: -1px;
            background: ${props => props.theme.color[props.mainColor]};
            content: '';
            z-index: -1;
            border-radius: 32px;
        }
    `}

    ${props =>
        props.archiveFilterActive &&
        css`
            box-shadow: none;
            &:hover {
                @media (min-width: 768px) {
                    box-shadow: none;
                }
            }   
        `
    }
`;